import React, { Component } from 'react';
import { toast } from 'react-toastify'
import AdmissionApi from '../../../../Services/AdmissionApi';
import CKEditor from "react-ckeditor-component";

class AdminCareerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      imageid: null,
      imageUrl: null,
      title: '',
      domain: '',
      skills: '',
      opportunities: '',
      status: 0,
      errors: {
        title: '',
        domain: '',
        skills: '',
        opportunities: '',
      },
      check: false
    }

    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setState({
        id: data.id,
        imageid: data.imageid,
        imageUrl: data.imageurl,
        title: data.title,
        domain: data.domain,
        skills: data.skills,
        opportunities: data.opportunities,
        status: data.status,
      })
    }
  }

  handlenewsMedia = (newResponse) => {
    if (newResponse.data.success) {
      let obj = {
        id: this.state.id,
        title: this.state.title,
        domain: this.state.domain,
        skills: this.state.skills,
        opportunities: this.state.opportunities,
        status: this.state.status,
        imageid: newResponse.data.attributes.id,
        qualities: 'but why'
      }

      this.admissionsService.updateCredentials(this.handleMedia, obj, 'v1/career');
    }
  }

  handleMedia = (newResponse) => {
    if (newResponse.data.success) {
      // console.log("meadia1"+JSON.stringify(newResponse));
    }
  }

  updateState = (newResponse) => {
    if (newResponse.data.success) {
      this.setState({
        id: newResponse.data.attributes.id
      });
      const data = new FormData()
      data.append('file', this.uploadInput.files[0]);
      if (this.uploadInput.files[0]) {

        data.append('title', this.state.title);
        data.append('description', this.state.domain);
        data.append('path', "v1/career/images");

        this.admissionsService.createMediaNew(this.handlenewsMedia, data, "v1/media/images");

      }
      this.props.updateRoutePage('careers')
    } else {
      let errors = {};
      if (newResponse.data.message) {
        errors['responseError'] = newResponse.data.message;
        this.setState({ errors: errors });
      } else {
        // this.errorsHandling(newResponse.data.errors);
      }

    };
  }

  handleValidation = () => {
    let fields = this.state;
    let formIsValid = true;
    let errors = {
      title: '',
      domain: '',
      skills: '',
      opportunities: '',
    }

    //Title
    if (!fields["title"]) {
      formIsValid = false;
      errors["title"] = "Cannot be empty";
    }


    //Description
    if (!fields["domain"]) {
      formIsValid = false;
      errors["domain"] = "Cannot be empty";
    }


    //Skills
    if (!fields["skills"]) {
      formIsValid = false;
      errors["skills"] = "Cannot be empty";
    }

    //Opportunities
    if (!fields["opportunities"]) {
      formIsValid = false;
      errors["opportunities"] = "Cannot be empty";
    }

    errors['responseError'] = '';

    this.setState({ errors });
    return formIsValid;
  }

  onSubmit = () => {
    if (!this.handleValidation()) return
    const {
      title,
      domain,
      skills,
      opportunities,
      id,
      imageid,
      status
    } = this.state

    let obj = {
      title,
      domain,
      skills,
      opportunities,
      status,
      qualities: 'but why'
    }

    if (id) obj['id'] = id
    if (imageid) obj['imageid'] = imageid

    if (!id) {
      this.admissionsService.createNew(
        res => {
          if(res.status === 200) {
            toast.success(("Career added successfully."))
            this.updateState()
          }
        },
        obj,
        'v1/career'
      )
    } else {
      this.admissionsService.updateCredentials(
        res => {
          if(res.status === 200) {
            toast.success(("Career updated successfully."))
            this.updateState()
          }
        },
        obj,
        'v1/career'
      )

    }
  }

  resetErrorMsg = (errorId) => {
    this.setState((preState) => ({
      errors: { ...preState.errors, [errorId]: "" },
    }))
  }

  handleFormFieldChange = (e) => {
    e.preventDefault()
    const { id, value } = e.target
    this.setState({
      [id]: value
    })

    this.resetErrorMsg(id)
  }

  handleEditorChange = (evt, id) => {
    var newContent = evt.editor.getData();
    this.setState({ [id]: newContent });
    this.resetErrorMsg(id)
  }

  render() {
    const {
      title,
      domain,
      skills,
      opportunities,
      errors
    } = this.state
    const { updateRoutePage } = this.props

    return (
      <div className="row">
        <div className="col-sm-12">
          <div className={`form-group ${errors["title"] && 'm-0'}`}>
            <label>Career Name</label>
            <input
              type="text"
              id="title"
              className="form-control alert-filter__input"
              placeholder="Career Name"
              value={title}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["title"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["domain"] && 'm-0'}`}>
            <label>Career Overview</label>
            <CKEditor
              content={domain}
              events={{
                change: (e) => this.handleEditorChange(e, 'domain')
              }}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["domain"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["skills"] && 'm-0'}`}>
            <label>Abilities and Qualities</label>
            <CKEditor
              content={skills}
              events={{
                change: (e) => this.handleEditorChange(e, 'skills')
              }}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["skills"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["opportunities"] && 'm-0'}`}>
            <label>Opportunities</label>
            <CKEditor
              content={opportunities}
              events={{
                change: (e) => this.handleEditorChange(e, 'opportunities')
              }}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["opportunities"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <label>Image</label>
            <div><input ref={(ref) => { this.uploadInput = ref }} type="file" /></div>
          </div>
        </div>
        <div className="col-12 text-right my-3">
          <button
            onClick={() => updateRoutePage('careers')}
            className="btn btn-link"
          >
            Cancel
          </button>
          <button
            onClick={() => this.onSubmit()}
            className="btn btn--primary ml-2"
          >
            Submit
          </button>
        </div>
      </div>
    )
  }
}

export default AdminCareerForm;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminCareers/AdminCareerForm/index.js
 **/